// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @bitwarden/platform/no-enums
export enum VerificationType {
  MasterPassword = 0,
  OTP = 1,
  PIN = 2,
  Biometrics = 3,
}
